import { cn } from '@/lib/utils'

export interface DetailRow {
	label: string
	value: string
	highlight?: boolean
}

export function DetailRowItem({ label, value, highlight = false }: DetailRow) {
	return (
		<div className='flex items-center justify-between gap-4 border-b border-border px-4 py-3.5 last:border-b-0 sm:px-6'>
			<span className='text-sm text-muted-foreground'>{label}</span>
			<span className={cn('text-right text-sm font-medium', highlight ? 'text-primary' : 'text-foreground')}>{value}</span>
		</div>
	)
}
